module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-06.185f977c.jpg";